import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { ErrorComponent } from './core/error/componets/error/error.component';
import { DeepLinkComponent } from './shared/components/deeplink/deeplink.component';

const routes: Routes = [
  {path: '', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)},
  {path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule), canActivate: [AuthGuard]}, //supervisor
  {path: 'realtor', loadChildren: () => import('./modules/realtor/realtor.module').then(m => m.RealtorModule), canActivate: [AuthGuard]}, //corretor
  {path: 'perfil/:id', component: DeepLinkComponent},
  {path: 'perfil/:id/:ad', component: DeepLinkComponent}, 
  {path: 'builder', loadChildren: () => import('./modules/builder/builder.module').then(m => m.BuilderModule), canActivate: [AuthGuard]}, //anunciante
  {path: 'proprietary', loadChildren: () => import('./modules/proprietary/proprietary.module').then(m => m.ProprietaryModule), canActivate: [AuthGuard]}, //central do proprietário
  {path: 'realestate', loadChildren: () => import('./modules/realestate/realestate.module').then(m => m.RealestateModule), canActivate: [AuthGuard]}, //imobiliária
  {path: '**', component: ErrorComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
}) 
export class AppRoutingModule { }

